import { render, staticRenderFns } from "./Loss.vue?vue&type=template&id=10c6b4ce&scoped=true&lang=pug&"
import script from "./Loss.vue?vue&type=script&lang=js&"
export * from "./Loss.vue?vue&type=script&lang=js&"
import style0 from "./Loss.vue?vue&type=style&index=0&id=10c6b4ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c6b4ce",
  null
  
)

export default component.exports